import type { ITextElement } from '@chainlit/react-client';

import { TextElement } from '@/components/Elements/Text';
import { formatCitationRefLabel } from '@/lib/message';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useTranslation } from 'components/i18n/Translator';

interface Props {
  items: ITextElement[];
}

const InlinedTextList = ({ items }: Props) => {
  const { i18n } = useTranslation();

  return (
    <div className="flex flex-col gap-2">
      {items.map((el) => {
        const title = formatCitationRefLabel(el.name, i18n.language);
        return (
          <Card key={el.id}>
            <CardHeader className="pb-2">
              <CardTitle className="text-sm font-medium">{title}</CardTitle>
            </CardHeader>
            <CardContent>
              <TextElement element={el} />
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};

export { InlinedTextList };
